import { render, staticRenderFns } from "./Textfield.vue?vue&type=template&id=f81ff0a2&scoped=true&"
import script from "./Textfield.vue?vue&type=script&lang=ts&"
export * from "./Textfield.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f81ff0a2",
  null
  
)

export default component.exports